import React, { useRef, useState } from 'react';
import './FormContactsMini.scss';
import './FormContactsMini-media.scss';
import InputPhone from '../Input/InputPhone';
import Button from '../Button/Button';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import { EnumUrlsPages } from '../../services/Enum';
import { Props } from './interfaces';
import {content} from "../../services/content";
import ErrorTextBlocked from "../ErrorTextBlocked/ErrorTextBlocked";
import {createPortal} from "react-dom";
import ModalFormFeedback from "../ModalFormFeedback/ModalFormFeedback";
import {SelectValuesFormSimple} from "../../services/content/Constants";
import AgreementCheckboxes from "../AgreementCheckboxes/AgreementCheckboxes"; // Added import

const FormContactsMini = ({
  blockedSend,
  widthWindow,
  eventMetrika,
  buttonText = content.mainBlock.getProposal,
  title
}: Props) => {
  const [phone, setPhone] = useState('+7');
  const [serverText, setServerText] = useState<string | null>(null);
  const [disableBtn, setDisableBtn] = useState(false);
  const [showBlockedError, setShowBlockedError] = useState(false);

  const [showModal, setShowModal] = useState(false);

  const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false);
  const [allowMarketing, setAllowMarketing] = useState(false);
  const [privacyErrorCount, setPrivacyErrorCount] = useState(0);

  const handleFormSubmit = async(e: any) => {
    e.preventDefault();
    console.debug('phone number on submit', phone);
    if (!privacyPolicyAccepted) {
        setPrivacyErrorCount(c => c + 1);
        return;
    }
    setShowModal(true);
  }

  return (
    <div className="form-contacts-mini">
      <form className="form-contacts-mini__form" onSubmit={handleFormSubmit}>
        <InputPhone
          label={content.mainBlock.phone}
          name="phone"
          value={phone}
          onChange={(e: any) => setPhone(e.target.value)}
          error={serverText}
        />

        <Button text={buttonText} size="M" widthAll={widthWindow < 720} disabled={disableBtn}/>

        {showBlockedError && blockedSend.state && <div className="form-contacts-mini__error-blocked-wrapper"><ErrorTextBlocked counter={blockedSend.counter}/></div>}

        <AgreementCheckboxes
            privacyChecked={privacyPolicyAccepted}
            onPrivacyChange={(checked) => {
              setPrivacyPolicyAccepted(checked);
              if (checked) setPrivacyErrorCount(0);
            }}
            marketingChecked={allowMarketing}
            onMarketingChange={setAllowMarketing}
            errorTrigger={privacyErrorCount}
        />
      </form>
      {createPortal(
        <ModalFormFeedback
          hasCssTransition
          showForm={showModal}
          id="feedback"
          title={title}
          select={{ options: SelectValuesFormSimple }}
          closedModal={() => setShowModal(false)}
          phoneNumber={phone}
          eventMetrika={eventMetrika}
          initialAllowMarketing={allowMarketing}
        />,
        document.body
      )}
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(FormContactsMini));
